// extracted by mini-css-extract-plugin
export default {"header-logo":"Header_header-logo__dbYTs","header-titulo":"Header_header-titulo__B8De9"};